import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './utils/auth';
import { CurrencyProvider } from './utils/currency';
import Sidebar from './components/Sidebar';
import AnimatedBackground from './components/AnimatedBackground';
import InstallPrompt from './components/InstallPrompt';
import Dashboard from './pages/Dashboard';
import PortfolioManager from './pages/PortfolioManager';
import ImportPortfolio from './pages/ImportPortfolio';
import AIAnalystChat from './pages/AIAnalystChat';
import DailyInsights from './pages/DailyInsights';
import StockScreener from './pages/StockScreener';
import LiveTicker from './pages/LiveTicker';
import AlertsSimulator from './pages/AlertsSimulator';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminPortal from './pages/AdminPortal';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#64748b' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AuthRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && !user.is_admin) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#64748b' }}>Loading...</div>;
  if (!user || !isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0a0f1c' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#00ff9d', fontSize: 28, fontWeight: 700, margin: '0 0 8px' }}>Retail Alpha</h1>
          <p style={{ color: '#64748b', fontSize: 14 }}>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <AnimatedBackground />
      <Routes>
        <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin/login" element={<Navigate to="/login" replace />} />
        <Route path="/admin" element={<AdminRoute><AdminPortal /></AdminRoute>} />
        <Route path="/*" element={
          <ProtectedRoute>
            <CurrencyProvider>
              <div className="app-layout">
                <InstallPrompt />
                <Sidebar />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/portfolio" element={<PortfolioManager />} />
                    <Route path="/import" element={<ImportPortfolio />} />
                    <Route path="/trade-import" element={<Navigate to="/import" replace />} />
                    <Route path="/sync-holdings" element={<Navigate to="/import" replace />} />
                    <Route path="/chat" element={<AIAnalystChat />} />
                    <Route path="/insights" element={<DailyInsights />} />
                    <Route path="/screener" element={<StockScreener />} />
                    <Route path="/ticker" element={<LiveTicker />} />
                    <Route path="/alerts" element={<AlertsSimulator />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
              </div>
            </CurrencyProvider>
          </ProtectedRoute>
        } />
      </Routes>
    </>
  );
}

export default App;
